// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_3IG-s","mask":"mask_8KEP-","block":"block_xLcF2","opacity":"opacity_R-gux"};